import styled from "styled-components"

export const Container = styled.div`
  background: #1D5F50;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  padding: 0 0.8rem;
  color: #b6e8cc;
  font-size: 1rem;
  margin-left: 1rem;
  height: 2rem;
`
